module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Horizontal-ac65923a32f3c3d78614a025e631b9f8.svg";